module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-menu"
  }, [(_vm.menu.length != 1) ? _c('el-tabs', {
    staticClass: "article_tab",
    class: {
      fixed: _vm.isFixed
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab_active),
      callback: function($$v) {
        _vm.tab_active = $$v
      },
      expression: "tab_active"
    }
  }, [_vm._l((_vm.menu), function(item, i) {
    return [_c('el-tab-pane', {
      attrs: {
        "name": item.name,
        "index": i,
        "label": item.name
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.menu.length != 1) ? _c('div', {
    staticStyle: {
      "padding-top": "60px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article_txt"
  }, [_vm._l((_vm.menu), function(item) {
    return [_c('h3', {
      staticClass: "article_title"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.text), function(i) {
      return [(i.indexOf('data:image') >= 0 || i.indexOf('png') >= 0 || i.indexOf('jpg') >= 0) ? _c('div', {
        staticClass: "img_box"
      }, [_c('img', {
        attrs: {
          "src": i
        }
      })]) : _c('div', {
        staticClass: "p_box"
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(i)
        }
      })])]
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3ef96147"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/tabs-menu.vue
// module id = 779
// module chunks = 1